import { connect } from "react-redux";
import * as actions_misc from "../../../_actions/misc";
import * as actions from "../../../_actions/search";
import Search from "../components/Search";

const mapStateToProps = ({ Search, Misc }) => ({
    search_order_id: Search.data.id,
    search_order_no: Search.data.order_no,
    search_email: Search.data.email,
    search_message: Search.message.value,
    search_results: Search.data,
    searchError: Search.fetching.err,
    loading: Search.fetching.loading,
    language: Misc.language.language,
    store: Misc.store.store,
    country: Misc.country.country,
    language_list: Misc.language.language_list,
    store_list: Misc.store.store_list,
    country_list: Misc.country.country_list,
    language_list_loading: Misc.language.fetching.loading,
    store_list_loading: Misc.store.fetching.loading,
    country_list_loading: Misc.country.fetching.loading
});

const mapDispatchToProps = dispatch => ({
    search: (order_no, email) => {
        dispatch(actions.search(order_no, email));
    },
    updateSearchMessage: message => {
        dispatch(actions.updateSearchMessage(message));
    },
    resetSearchMessage: () => {
        dispatch(actions.resetSearchMessage());
    },
    resetSearchResult: () => {
        dispatch(actions.resetSearchResult());
    },
    setLanguage: language => {
        dispatch(actions_misc.setLanguage(language));
    },
    setStore: store => {
        dispatch(actions_misc.setStore(store));
    },
    setCountry: country => {
        dispatch(actions_misc.setCountry(country));
    },
    resetLanguage: () => {
        dispatch(actions_misc.resetLanguage());
    },
    resetStore: () => {
        dispatch(actions_misc.resetStore());
    },
    resetCountry: () => {
        dispatch(actions_misc.resetCountry());
    },
    getLanguages() {
        dispatch(actions_misc.getLanguages());
    },
    getStores() {
        dispatch(actions_misc.getStores());
    },
    getCountries() {
        dispatch(actions_misc.getCountries());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);
